"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePagination = void 0;
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = require("react");
const usePagination = _ref => {
  let {
    currentPage,
    onChange,
    total,
    entitiesPerPage,
    ...hookOverrides
  } = _ref;
  const maxPage = Math.ceil(total / entitiesPerPage);
  if (process.env.NODE_ENV !== "production") {
    if (currentPage < 1 || currentPage > maxPage) {
      console.warn(`usePagination: currentPage is out of bounds: ${currentPage}. It should be 1 <= currentPage (${currentPage}) <= maxPage (${maxPage}). This will probably mean the pagination component renders incorrectly.`);
    }
  }
  const internalNextHandler = (0, _react.useCallback)(() => {
    const newPage = currentPage + 1;
    if (newPage <= maxPage) {
      onChange(newPage);
    }
  }, [currentPage, maxPage, onChange]);
  const internalPrevHandler = (0, _react.useCallback)(() => {
    const newPage = currentPage - 1;
    if (newPage >= 1) {
      onChange(newPage);
    }
  }, [onChange, currentPage]);
  const internalFirstPageHandler = (0, _react.useCallback)(() => {
    if (currentPage !== 1) {
      onChange(1);
    }
  }, [currentPage, onChange]);
  const internalLastPageHandler = (0, _react.useCallback)(() => {
    if (currentPage !== maxPage) {
      onChange(maxPage);
    }
  }, [currentPage, maxPage, onChange]);

  // In the case where the currentPage is out of the proper range, we'll coerce it here to make
  // sure the Pagination component doesn't throw errors.
  const coercedCurrentPage = Math.max(1, Math.min(currentPage, maxPage));
  return {
    getPaginationProps: (0, _react.useCallback)(function () {
      let {
        onFirstPageClick,
        onLastPageClick,
        onNextClick,
        onPrevClick,
        ...propGetterOverrides
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return {
        ...hookOverrides,
        ...propGetterOverrides,
        onFirstPageClick: (0, _lodestarUtils.callAllHandlers)(onFirstPageClick, internalFirstPageHandler),
        onLastPageClick: (0, _lodestarUtils.callAllHandlers)(onLastPageClick, internalLastPageHandler),
        onNextClick: (0, _lodestarUtils.callAllHandlers)(onNextClick, internalNextHandler),
        onPrevClick: (0, _lodestarUtils.callAllHandlers)(onPrevClick, internalPrevHandler),
        from: (coercedCurrentPage - 1) * entitiesPerPage + 1,
        entitiesPerPage,
        total
      };
    }, [coercedCurrentPage, entitiesPerPage, hookOverrides, internalFirstPageHandler, internalLastPageHandler, internalNextHandler, internalPrevHandler, total])
  };
};
exports.usePagination = usePagination;
//# sourceMappingURL=usePagination.js.map